import type { PaymentMethodFieldQuerySchema } from '../schemas/payment-method-field-query-schema';

export type PaymentMethodFieldTypeOption = {
  name: string;
  value: PaymentMethodFieldQuerySchema['type'];
};

const OPTIONS: PaymentMethodFieldTypeOption[] = [
  { name: 'Text', value: 'text' },
  { name: 'Select', value: 'select' },
];

export function paymentMethodFieldTypeOptions(): PaymentMethodFieldTypeOption[] {
  return OPTIONS;
}

export function paymentMethodFieldTypeToOption(
  type: PaymentMethodFieldQuerySchema['type']
): PaymentMethodFieldTypeOption {
  return paymentMethodFieldTypeOptions().find((o) => o.value === type) ?? paymentMethodFieldTypeOptions()[0]!;
}
